import type { State } from '~~/domains/ux';
import { useLayoutStore } from '~~/domains/ux';

export function useHeaderConfiguration(
  configuration: Partial<State['header']>,
) {
  const layoutStore = useLayoutStore();

  layoutStore.$patch({ header: configuration });
}
